
















































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import LabelSlot from '@/shared/slots/label-slot.component.vue';
import Rules from '@/shared/rules/rules';
import WebhookService from './webhook.service';
import WebhookType from './webhook-type.entity';
import WebhookForm from './webhook-form.entity';

@Component({
  components: { LabelSlot },
})

export default class ServiceHookDialog extends Vue {
  @Prop({
    type: Boolean,
    default: false,
  })
  private value!: boolean;

  @Prop({
    type: WebhookForm,
    required: true,
  })
  private webhook!: WebhookForm;

  @Prop({
    type: Boolean,
    default: false,
  })
  private readOnly!: boolean;

  private rules: Rules = new Rules();

  private webhookTypes: WebhookType[] = [];

  private loadingWebhookTypes: boolean = true;

  private closeDialog(): void {
    this.$emit('input', false);
    this.resetFormValidation();
  }

  private formatWebhookTypeLabel(webhookType: WebhookType): string {
    return `${webhookType.methodType} - ${webhookType.name}`;
  }

  private updateField(field: string, value: any): void {
    this.$emit(`update:${field}`, value);
  }

  private loadWebhookTypes(): void {
    this.loadingWebhookTypes = true;
    WebhookService.getWebhookTypes().then((webhookTypes: WebhookType[]) => {
      this.webhookTypes = webhookTypes;
    }).finally(() => {
      this.loadingWebhookTypes = false;
    });
  }

  private resetFormValidation(): void {
    const form: any = this.$refs.form;
    form.resetValidation();
  }

  private save(): void {
    const form: any = this.$refs.form;
    if (form.validate()) {
      this.$emit('save');
      this.closeDialog();
    }
  }

  private created(): void {
    this.loadWebhookTypes();
  }
}

